// vendors
import React from 'react';
import { i18n } from 'core/i18n';
import PropTypes from 'prop-types';
// components
import DepositOffersItemCard from '../depositOffersItemCard/depositOffersItemCard';
// constants
import { poeKeys } from './constants/poeKeys';
// helpers
import { getDateCamelCaseShortMonth } from 'utilities/dateHelper';
import { getOfferText, isLastDay } from '../../helpers/depositOffersItemHelper';

const DepositOfferItem = ({ 
    amount, 
    name, 
    tin, 
    tae, 
    daysLeft, 
    expirationDate, 
    months,
    isLargeDisplayOption,
    isRobinson, 
    isPostRenovation, 
    handleClick, 
    multipleOffers, 
    examplesIndex ,
    onOpenRemoveOfferModal
}) => {
    const { formatText, FormattedText } = i18n;

    let offerBodyTagText;
    if (isLastDay(isPostRenovation, daysLeft)) {
        offerBodyTagText = poeKeys.lastDayTag;
    } else if (isPostRenovation) {
        offerBodyTagText = poeKeys.postRenovationTag;
    } else {
        offerBodyTagText = poeKeys.tag;
    }

    const formattedDate = getDateCamelCaseShortMonth(expirationDate, true);

    let asterisks = '';
    for (let i = 0; i < examplesIndex; i++) {
        asterisks += '*';
    }

    const isAmountIncluded = !isRobinson && !isPostRenovation;
    const reducedDynamicValues = [name, ...(isPostRenovation ? [] : [formattedDate]), ...(isAmountIncluded ? [amount] : []), tin, asterisks, months];
    const completeDynamicValues = [name, ...(isPostRenovation ? [] : [formattedDate]), ...(isAmountIncluded ? [amount] : []), tae, asterisks, tin, months];
    const dynamicValues = !tae || tae === tin ? reducedDynamicValues : completeDynamicValues;
    const offerText = <FormattedText value={getOfferText(isRobinson, isPostRenovation, tae, tin, poeKeys)} injectedStrings={dynamicValues} />;

    const buttonText = multipleOffers ? formatText(poeKeys.buttonMultipleOffers) : formatText(poeKeys.button);
    const buttonRemoveOfferText = formatText(poeKeys.buttonRemoveOffer)

    return (
        <DepositOffersItemCard 
            offerText={offerText} 
            tagText={offerBodyTagText} 
            tagStrings={isLastDay(isPostRenovation, daysLeft) ? undefined : [daysLeft]}
            buttonText={buttonText}
            buttonRemoveOfferText={buttonRemoveOfferText}
            handleClick={handleClick}
            isAlternativeFlavor={isPostRenovation}
            isLargeDisplayOption={isLargeDisplayOption}
            onOpenRemoveOfferModal={onOpenRemoveOfferModal}
        />
    );
};

PropTypes.DepositOfferItem = {
    amount: PropTypes.string.isRequired,
    daysLeft: PropTypes.number.isRequired,
    expirationDate: PropTypes.string.isRequired,
    handleClick: PropTypes.func.isRequired,
    isRobinson: PropTypes.bool.isRequired,
    months: PropTypes.number.isRequired,
    multipleOffers: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onOpenRemoveOfferModal: PropTypes.func,
    tae: PropTypes.string.isRequired,
    tin: PropTypes.string.isRequired,
}

DepositOfferItem.defaultProps = {
    onOpenREmoveOfferModal: () => {}
}

export default DepositOfferItem;